import React from "react";

import Color from "../Color";

const connectionStyle = {
  fill: "none",
  stroke: Color.gradientMid,
  strokeWidth: 1,
  zIndex: -1
};

function Connection({ x1, y1, x2, y2 }) {
  return (
    <polyline
      points={`${x1},${(y1 + y2) / 2} ${x2},${(y1 + y2) / 2} ${x2},${y2}`}
      style={connectionStyle}
    />
  );
}

export function ConnectionRoot({ x, y1, y2 }) {
  return (
    <polyline
      points={`${x},${y1} ${x},${(y1 + y2) / 2}`}
      style={connectionStyle}
    />
  );
}

export default Connection;
